import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY
const apiUrl_admin = process.env.REACT_APP_API_KEY_ADMIN
export const getActiveOperators = async (setDataTable) => {
    await api.get(`${urlApi}/talentoHumano/getPersonal`).then((res) => {
        setDataTable(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getInactiveOperators = async (setDataTable) => {
  await  api.get(`${urlApi}/talentoHumano/getOperadoresInactivos`).then((res) => {
        setDataTable(res.data)
    })
        .catch((error) => {
            //console.log("error", error);
        })
}

export const getLicencias = (setDatatable) => {
    api.get(`${urlApi}/talentoHumano/getLicences`).then((res) => {
        setDatatable(res.data)
    })
        .catch((error) => {
            // console.log("error", error);
        })
}

export const getUnidades = async (setDatatable) => {
    await api.get(`${urlApi}/operaciones/getUnits`).then((res) => {
        setDatatable(res.data)
    })
        .catch((error) => {
            // console.log("error", error);
        })
}


export const updatePersonal = async (id, data) => {
    try {


        // Crear una copia de los datos para no mutar el objeto original
        const dataToSend = { ...data };

        // Convertir el campo ACTIVO a 1 o 0 si existe y es un booleano
        if (typeof dataToSend.ACTIVO === 'boolean') {
            dataToSend.ACTIVO = dataToSend.ACTIVO ? 1 : 0;
        }


        const res = await api.patch(`${urlApi}/talentoHumano/updateChofer`, dataToSend);

        // Swal.fire({
        //     title: "Éxito",
        //     text: "Datos actualizados correctamente",
        //     icon: "success",
        //     confirmButtonText: "Aceptar"
        // });
        return res.data;
    } catch (error) {
        // Puedes intentar extraer un mensaje de error más específico de la respuesta de la API
        let errorMessage = "No se pudo actualizar el personal";
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        // Swal.fire({
        //     title: "Error",
        //     text: errorMessage,
        //     icon: "error",
        //     confirmButtonText: "Aceptar"
        // });
        // Opcional: relanzar el error si quieres manejarlo más arriba en la cadena de llamadas
        throw error;
    }
};


// parte de agregar usuario 
export const getOperadoresSinUsuarioAsignado = async (setOperadoresSinUsuario) => {
    api.get(`${apiUrl_admin}/admin/getOperadoresSinUsuario`)
        .then((res) => {
            setOperadoresSinUsuario(res.data)
     

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getUsuarios = async (setUsuarios) => {
    await api.get(`${apiUrl_admin}/admin/getUsuarios`)
        .then((res) => {
            setUsuarios(res.data)
         

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getColaboradoresSinUsuario = async (setStatus) => {

    await api.get(`${urlApi}/talentoHumano/getColaboradoresSinUsuario`)
        .then((res) => {
            setStatus(res.data)
        })
        .catch((error) => {
            // Swal.close();
            console.log("error", error);

        })
}
export const addUsuarios = async (params) => {

    // Swal.fire({
    //     title: 'Cargando...',
    //     text: 'Obteniendo datos...',
    //     allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
    //     allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
    //     didOpen: () => {
    //         Swal.showLoading();     // Muestra el spinner de carga
    //     }
    // });
    await api.post(`${urlApi}/talentoHumano/addUsuarios`, params)
        .then((res) => {
            // Swal.close();

        })
        .catch((error) => {
            // Swal.close();
            console.log("error", error);

        })
}
export const updateUsuarios = async (params) => {


    await api.patch(`${urlApi}/talentoHumano/editUsuarios`, params)
        .then((res) => {

            // Swal.close();

        })
        .catch((error) => {
            // Swal.close();
            console.log("error", error);

        })
}
export const getLineasTelefono = async (setLineasTelefono) => {
    api.get(`${apiUrl_admin}/admin/getTelefonosDisponibles`)
        .then((res) => {
            setLineasTelefono(res.data)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTodosLosUsuarios = (setTodosLosUsuarios) => {
    api.get(`${apiUrl_admin}/admin/getTodosLosUsuarios`)
        .then((res) => {
            setTodosLosUsuarios(res.data)

        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getPuestos = (setPuestos) => {
    api.get(`${apiUrl_admin}/admin/getPuestos`)
        .then((res) => {
            setPuestos(res.data)

        })
        .catch((error) => {
            console.log("error", error);

        })
}